var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHappy = function SvgHappy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2a5 5 0 0 0-5 5v10a5 5 0 0 0 5 5h10a5 5 0 0 0 5-5V7a5 5 0 0 0-5-5H7Zm1.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6.5 4.129c0-1.26-.776-1.182-1.876-1.073-.347.035-.726.073-1.124.073-.398 0-.777-.038-1.124-.073C9.776 13.946 9 13.87 9 15.13a3 3 0 0 0 6 0ZM15.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "#007852"
  })));
};

export default SvgHappy;